<div class="setting-page">
    <mat-card class="settings-card">
        <div class="card-header">
            <div>
                <h2>Company settings</h2>
                <p *ngIf="companyId">Editing company {{ companySettings.name || 'selected company' }} ({{ companyId }})</p>
            </div>

            <button mat-stroked-button type="button" (click)="reloadCompanySettings()" [disabled]="isLoading || isSaving">
                Reload
            </button>
        </div>

        <div *ngIf="isLoading" class="state-message">
            Loading company settings...
        </div>

        <div *ngIf="!isLoading && companyNotFound" class="state-message error-state">
            No company document was found for the selected company.
        </div>

        <div *ngIf="!isLoading && !companyNotFound" class="settings-content">
            <div class="upload-section">
                <label class="upload-label" for="file">Upload logo</label>
                <input id="file" type="file" (change)="upload($event)" accept="image/*" />
                <div class="result" *ngIf="uploadURL | async; let uploadSrc">
                    <a [href]="uploadSrc" target="_blank" rel="noreferrer">Open uploaded logo</a>
                </div>
            </div>

            <form class="company-settings-form">
                <div class="field-grid two-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Company name</mat-label>
                        <input matInput [(ngModel)]="companySettings.name" name="name">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Text color</mat-label>
                        <input matInput [(ngModel)]="companySettings.textColor" name="textColor">
                    </mat-form-field>
                </div>

                <div class="toggle-grid">
                    <mat-slide-toggle [(ngModel)]="companySettings.isApplePayActive" name="isApplePayActive">
                        Apple Pay active
                    </mat-slide-toggle>

                    <mat-slide-toggle [(ngModel)]="companySettings.isCardActiveOverAll" name="isCardActiveOverAll">
                        Card active overall
                    </mat-slide-toggle>

                    <mat-slide-toggle [(ngModel)]="companySettings.isGooglePayActive" name="isGooglePayActive">
                        Google Pay active
                    </mat-slide-toggle>

                    <mat-slide-toggle [(ngModel)]="companySettings.isVippsGlobalActive" name="isVippsGlobalActive">
                        Vipps active globally
                    </mat-slide-toggle>

                    <mat-slide-toggle [(ngModel)]="companySettings.overrideColor" name="overrideColor">
                        Override colors
                    </mat-slide-toggle>

                    <mat-slide-toggle [(ngModel)]="companySettings.overrideWindowMessage" name="overrideWindowMessage">
                        Override window message
                    </mat-slide-toggle>
                </div>

                <div class="field-grid colors-grid">
                    <label class="color-field">
                        <span>Theme color</span>
                        <div class="color-input-row">
                            <input type="color" [(ngModel)]="companySettings.themeColor" name="themeColorPicker">
                            <input matInput [(ngModel)]="companySettings.themeColor" name="themeColor">
                        </div>
                    </label>

                    <label class="color-field">
                        <span>Window color</span>
                        <div class="color-input-row">
                            <input type="color" [(ngModel)]="companySettings.windowColor" name="windowColorPicker">
                            <input matInput [(ngModel)]="companySettings.windowColor" name="windowColor">
                        </div>
                    </label>
                </div>

                <mat-form-field appearance="outline">
                    <mat-label>Window message</mat-label>
                    <textarea
                        matInput
                        rows="4"
                        [(ngModel)]="companySettings.windowMessage"
                        name="windowMessage"></textarea>
                </mat-form-field>

                <div class="preview-card" [style.background]="companySettings.overrideColor ? companySettings.windowColor : '#f3f1ee'"
                    [style.color]="companySettings.overrideColor ? companySettings.textColor : '#2d2926'">
                    <div class="preview-title">Preview</div>
                    <div class="preview-message">
                        {{ companySettings.overrideWindowMessage ? companySettings.windowMessage : 'Window message override is disabled.' }}
                    </div>
                </div>

                <div class="actions-row">
                    <button mat-raised-button color="primary" type="button" (click)="saveCompanySettings()" [disabled]="isSaving">
                        {{ isSaving ? 'Saving...' : 'Save company settings' }}
                    </button>
                </div>
            </form>
        </div>
    </mat-card>
</div>